import {useResultPageStore} from '../stores/ResultPageStore';
import Job from './../model/Job';
import {EVENT_JOB_COMPLETE, EVENT_JOB_FAIL, EVENT_JOB_INIT_SUCCESS, EVENT_JOB_START} from '../events/job.events';
import {
    JOB_STATE_COMPLETE,
    JOB_STATE_FAILED,
    JOB_STATE_INCOMPLETE,
    JOB_STATE_NOT_FOUND,
    JOB_STATE_PROCESSING,
    JOB_STATE_CANCELLED,
    JOB_STATE_UNAUTHORIZED,
} from '../const/job.const';
import {EventBus} from '../events/event.bus';
import ApiManager from './ApiManager';
import {decodeBase64ToImageUrl, encodeImageToBase64} from '../../../../../helper/base64';
import {satReconvert} from '../../../../../../lib-sat/result/util/reconvert';
import Analytics from "../util/Analytics";
import {testIsNonEmptyString} from "../../../../../../lib/test-and-assert/test-base";
import DownloadCookieManager from './DownloadCookieManager';
import { satGlobals } from '../../../../../sat/helper/sat-globals';

class JobManager {
    listener = false;

    constructor() {
    }

    create() {
        this.store = useResultPageStore();

        const job = new Job();
        job.settings.prompt = '';
        this.store.addJob(job);

        return job.id;
    }

    async delete(job) {
        Analytics.send('result_job', 'delete', job);
        await ApiManager.delete(job.apiJob.id);
    }

    async getShareAccessScope(job) {
        var result = await ApiManager.getShareAccessScope(job.apiJob.id);
        return result.data;
    }

    async setShareAccessScope(job, scope) {
        Analytics.send('result_job', 'share_access', job);
        await ApiManager.setShareAccessScope(job.apiJob.id, {scope});
    }

    async initFromJobId(id, apiId) {
        this.store = useResultPageStore();
        let job = this.store.getJobById(id);
        job.state = JOB_STATE_PROCESSING;

        let apiJob = await ApiManager.get({id: apiId});

        if (403 === apiJob || 401 === apiJob) {
            Analytics.send('result_job', 'unauthorized', this.store.getJobById(id));

            this.store.getJobById(id).state = JOB_STATE_UNAUTHORIZED;
            EventBus.$emit(JOB_STATE_UNAUTHORIZED, {});

            return;
        }

        if (404 === apiJob) {
            this.store.getJobById(id).state = JOB_STATE_NOT_FOUND;
            Analytics.send('result_job', 'not_found', {apiJob: {id: apiId}});


            return;
        }

        job.apiJob = apiJob;
        window.qgJob = apiJob;

        EventBus.$emit(EVENT_JOB_INIT_SUCCESS, job);

        await this._waitUntilComplete(id, apiJob);
    }

    async _waitUntilComplete(id, job, incomplete = 0) {
        this.store = useResultPageStore();

        let apiJob = await ApiManager.get(job);

        if (403 === apiJob || 401 === apiJob) {
            Analytics.send('result_job', 'unauthorized', this.store.getJobById(id));

            this.store.getJobById(id).state = JOB_STATE_UNAUTHORIZED;
            EventBus.$emit(JOB_STATE_UNAUTHORIZED, {});

            return;
        }

        if (404 === apiJob) {
            this.store.getJobById(id).state = JOB_STATE_NOT_FOUND;

            return;
        }

        if (null === apiJob) {
            setTimeout(() => {
                this._waitUntilComplete(id, job, ++incomplete);
            }, 2000);

            return;
        }
        

        window.qgJob = apiJob;
        this.store.getJobById(id).apiJob = apiJob;

        if (apiJob.status.code === JOB_STATE_FAILED) {
            Analytics.send('result_job', 'failed', this.store.getJobById(id));

            this.store.getJobById(id).state = JOB_STATE_FAILED;
            EventBus.$emit(EVENT_JOB_FAIL, {});

            return;
        }

        if (apiJob.status.code === JOB_STATE_CANCELLED) {
            Analytics.send('result_job', 'cancelled', this.store.getJobById(id));

            this.store.getJobById(id).state = JOB_STATE_CANCELLED;
            EventBus.$emit(EVENT_JOB_FAIL, {});

            return;
        }

        if (apiJob.status.code === JOB_STATE_COMPLETE) {
            Analytics.send('result_job', 'complete', this.store.getJobById(id));
            
            if(testIsNonEmptyString(apiJob.sat.download_password)){
                DownloadCookieManager.setDownloadCookie(apiJob.sat.download_password)
            }

            this.store.getJobById(id).state = this.store.getJobById(id).apiJob.status.code;
            this._populateBase64Images(id);

            EventBus.$emit(EVENT_JOB_COMPLETE, this.store.getJobById(id))
            
            return;
        }

        if (apiJob.status.code === JOB_STATE_INCOMPLETE) {

            if (incomplete > 60) {
                Analytics.send('result_job', 'failed_incomplete', this.store.getJobById(id));

                job.state = JOB_STATE_FAILED;
                this.store.getJobById(id).state = JOB_STATE_FAILED;

                return;
            }

            setTimeout(() => {
                this._waitUntilComplete(id, job, ++incomplete);
            }, 2000);

            return;
        }

        setTimeout(() => {
            this._waitUntilComplete(id, job);
        }, 2000);

        return;
    }

    _populateBase64Images(id) {
        return;
        this.store = useResultPageStore();

        let job = this.store.getJobById(id);

        job.apiJob.output.forEach((output) => {
            encodeImageToBase64(output.uri).then((base64String) => {
                if (null === base64String) {
                    job.state = JOB_STATE_FAILED;
                }
                job.base64_output_images.push(decodeBase64ToImageUrl(base64String));
            }).catch((err) => {
                job.state = JOB_STATE_FAILED;
            }).finally(() => {
                if (job.state === JOB_STATE_FAILED) {
                    EventBus.$emit(EVENT_JOB_FAIL, {});
                }
            });
        });
    }

    listen() {
        if (this.listener === true) {
            return;
        }

        this.listener = true;

        EventBus.$on(EVENT_JOB_START, (data) => {
            this.start(data.id);
        });
    }

    openOperation(id, operation) {
        this.store = useResultPageStore();

        const job = this.store.getJobById(id);

        let operationLink = job.apiJob.sat_links.reconvert.filter((obj) => {
            return obj.operation === operation;
        });

        satReconvert.redirectWithStorage(operationLink[0].href.link, job.apiJob.output[0].uri);
    }

    getExtensionFromOutput(output) {
        let lastDotIndex = output.uri.lastIndexOf('.');
        return output.uri.substring(lastDotIndex + 1);
    }

    getFilenameFromOutput(output) {
        let lastDotIndex = output.uri.lastIndexOf('/');
        return output.uri.substring(lastDotIndex + 1);
    }

    getInputByOutputSource(output, job) {
        return job.apiJob.input.filter((obj) => {
            return obj.id_api === output.source.input[0] || obj.id === output.source.input[0];
        });
    }

    getInputByWarningSource(warning, job) {
        return job.apiJob.input.filter((obj) => {
            return obj.id_api === warning.id_source || obj.id === warning.id_source;
        });
    }

    getInputById(inputid, job) {
        return job.apiJob.input.filter((obj) => {
            return obj.id_api === inputid || obj.id === inputid;
        });
    }

    getMissingInputs(job) {
        let missingIds = this.getMissingInputIds(job);
        let missingInputs = [];

        missingIds.forEach((inputId) => {
            let missingInput = this.getInputById(inputId, job);
            missingInputs.push(missingInput[0]);
        });

        return missingInputs;
    }

    getMissingInputIds(job) {
        const inputIds = this.getInputIdsFromJob(job);
        const inputIdsFromOutputs = this.getInputIdsFromOutputs(job);

        return inputIds.filter((id) => !inputIdsFromOutputs.includes(id));
    }

    getInputIdsFromJob(job) {
        let inputIds = [];

        const inputs = job.apiJob.input;

        inputs.forEach((input) => {
            if (testIsNonEmptyString(input.id_api)) {
                inputIds.push(input.id_api);
            } else {
                inputIds.push(input.id);
            }
        });

        return inputIds;
    }


    getInputIdsFromOutputs(job) {
        let inputIds = [];

        const outputs = job.apiJob.output;

        outputs.forEach((output) => {
            inputIds = inputIds.concat(output.source.input);
        });

        return inputIds;
    }

    isCompressJob(job) {
        if (job.apiJob.sat.operation.includes('compress')) {
            return true;
        }

        if (job.apiJob.sat.operation === 'compress') {
            return true;
        }

        return false;
    }

    getOutputCompressDiff(output, job) {
        let input = this.getInputByOutputSource(output, job);
        if (input.length === 0) {
            return {
                diff_size: 0,
                diff_perc: 0
            };
        }

        return {
            diff_size: input[0].size - output.size,
            diff_perc: (100 - ((100 / input[0].size) * output.size)).toFixed(2)
        };
    }

    isResizeJob(job) {
        if (job.apiJob.sat.operation.includes('resize')) {
            return true;
        }

        if (job.apiJob.sat.operation === 'resize') {
            return true;
        }

        return false;
    }

    isOutputSmaller(output, job) {
        let input = this.getInputByOutputSource(output, job);
        if (input.length === 0) {
            return null;
        }

        return output.size < input[0].size;
    }
}

export default new JobManager();
